import types from 'actions/types'
import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'

const showCompleted = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_ACTIVITIES_UPDATE_FILTERS: return (action.filters.hasOwnProperty('showCompleted')) ? action.filters.showCompleted : state
    default: return state
  }
}

const showRejected = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_ACTIVITIES_UPDATE_FILTERS: return (action.filters.hasOwnProperty('showRejected')) ? action.filters.showRejected : state
    default: return state
  }
}

export const activitiesTabPivotTableKey = 'quotingContext.selected.activitiesTab.pivotTable'

export default combineReducers({
  showCompleted,
  showRejected,
  pivotTable: createPivotTableReducer({key: activitiesTabPivotTableKey, defaultSortColumn: 'startDate'}),
})
